import { atom } from "recoil";

export const openedDidomiModalState = atom<boolean>({
  key: "openedDidomiModalState",
  default: false,
});
